export const TYPE_OF_FIELD_IN_COLUMN = {
  STRING: 'string',
  NUMBER: 'number',
  ACTIONS: 'actions',
  PERCENTAGE: 'percentage',
  PERCENTAGEBAR: 'percentage_bar',
  PERCENTAGEINDETAIL: 'percentage_in_detail',
  SENTIMENT: 'sentiment',
  SENTIMENTINDETAIL: 'sentiment_in_detail',
  MOMENTS: 'moment',
  STATUS: 'status',
  DATE: 'date',
  ARRAY: 'array',
  BOOLEAN: 'boolean',
  TIME: 'time',
  OBJECT: 'object'
};
export function ensureArray(input) {
  if (!input) {
    return null;
  }
  if (Array.isArray(input)) {
    // If it's already an array, return it as is
    return input;
  } else {
    // If it's not an array, wrap it in an array and return
    return [input];
  }
}
